export const constants = {
  GET_IP: "https://api.ipify.org/?format=json",
  TIMESTAMP_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DATE_FORMAT: "YYYY-MM-DD",
  NO_INTERNET_CONNECTION_MSG: "No Internet Connection",
  ROLE: {
    AGENT: "agent",
    USER: "user",
  },
  BUSINESS_CATEGORIES: [{ value: "Individual" }, { value: "Corporate" }],
  PAGE_LIMIT: 10,
  STARTING_PAGE: 1,
  BUSINESS_CATEGORIES_INDIVIDULES: "Individual",
  BUSINESS_CATEGORIES_CORPORATE: "Corporate",
  LOCALSTORAGE_DB_KEY_NAME: "PWA-Angular-STARTER",
  MOBILE_NUMBER: "Mobile Number",
  EMAIL: "Email Address",
  OTP_FROM: {
    SIGN_UP_MOBILE: "signUpMobile",
    SIGN_UP_EMAIL: "signUpEmail",
    FORGOT_PASSWORD_MOBILE: "forgotPasswordMobile",
    FORGOT_PASSWORD_EMAIL: "forgotPasswordEmail",
  },
  X_TEXT: "xxxx - xxxx - xxxx - ",
  PAYMENT_TYPES: {
    CRAD: "card",
    BANK: "bank",
  },
  RESEND_OTP_TIME: 120,
  AGENT_DOCUMENT_REQUIRED: {
    INDIVIDUAL: {
      ID_CARD: "ID Card",
      BANK_STATMENT: "Bank Statement",
    },
    CORPORATE: {
      CAC_CERTIFICATE: "CAC Certificate",
      CAC_FROM_A: "CAC Form A",
      UTILITY_BILL: "Utility Bill",
      MEANS_OF_IDENITIFICATION: "Means of Identification for one director",
    },
  },
  AGENT_DOCUMENT_DATA: {
    INDIVIDUAL: [
      { value: "ID Card", fromControlName: "idCard" },
      { value: "Bank Statement", fromControlName: "BankStatment" },
    ],
    CORPORATE: [
      { value: "CAC Certificate", fromControlName: "cacCertificate" },
      { value: "CAC Form A", fromControlName: "cacFromA" },
      { value: "Utility Bill", fromControlName: "utilityBill" },
      {
        value: "Means of Identification for one director",
        fromControlName: "meansOfIdenitification",
      },
    ],
  },
  FILE_UPLOAD_SIZE_LIMIT: 10000000,
  KYC_STATUS: {
    VERIFIED: "Verified",
    NOT_VERIFIED: "NotVerified",
  },
  WALLET_SETUP_TYPE: {
    BANK: "bank",
    CARD: "card",
  },
  DOCUMENT_UPLOAD_FILE_EXTENSION: ".pdf,.jpg,.jpeg, .png",
  SET_KYC: "setKyc",
};

export const KYC_STATUS = {
  VERIFIED: "Verified",
  UNVERIFIED: "NotVerified",
};

export const PROFILE_CONTROLS = {
  FIRSTNAME: "firstName",
  LASTNAME: "lastName",
  EMAIL: "email",
  MOBILE: "mobile",
};

export const LOCAL_STORAGE_KEYS = {
  TOKEN: "token",
  DATAOFBIRTH: "dateOfBirth",
  FIRSTNAME: "firstname",
  LASTNAME: "lastname",
  PROFILE: "profile",
  ADDRESS: "address",
  COUNTRY: "country",
  REGION: "region",
  CITY: "city",
  ADDRESSMORE: "addressMore",
  ID: "id",
  ROLE: "role",
  MOBILE: "mobile",
  MOBILECOUNTRYCODE: "mobileCountryCode",
  BUSINESS_CATEGORIES: "businessCategories",
  KYC_STATUS: "kycStatus",
  EMAIL: "email",
  DEVICE_ID: "deviceId",
  USER_TYPE: "USER",
  IS_TRANSACTION_PIN: "isTransactionPin",
  QR_CODE: "qrCode",
  BUSINESS_NAME: "businessName",
  SKIP_KYC: "skipKyc",
  CURRENCY_SYMBOL: "currencySymbol",
};

export const USER_ROUTES = {
  SIGN_UP: "user/sign-up",
  VERIFY_OTP: "merchant/verify-email-otp",
  RESEND_OTP: "user/resend-otp",
  SIGN_IN: "auth/login",
  BALANCE_DATA: "payment/money/merchant/dashboard",
  MERCHANT_THINGS_TO_DO:
    "admin/banner/user/banner?bannerUserHomePage=false&bannerUserPayPage=false&bannerMerchantHomePage=true",
  ANALYTICS_DATA: "payment/money/transaction-history/report/merchant",
  POST_CLICK: "admin/banner/user/click",
  POST_BANNER_CLOSE: "admin/banner/user/close",
  DASHBOARD_GRAPH_DATA: "merchant/merchant-dashboard-graph",
  FORGOT_PASSWORD: "merchant/send-email-otp",
  VERIFY_PASSWORD_LINK: "user/reset-password?",
  RESET_PASSWORD: "user/reset-password",
  SAVE_PHONE: "user/send-phone-otp-for-update",
  ADDERESS_UPDATE: "user/save-details",
  SEND_EMAILOTP_UPDATE: "user/send-email-otp-for-update",
  RESET_CONFIRM_PASSWORD: "user/edit-password",
  VERIFY_EMAIL: "user/verify-email?uniqueCode=",
  VERIFY_EMAIL_OTP: "user/verify-email-otp-for-update",
  VERIFY_PHONE_OTP: "user/verify-phone-otp-for-update",
  CHANGE_PASSWORD: "merchant/change-password",
  CHANGE_EXPLOREPIN: "user/change-explorepin",
  UPLOAD_DOCUMENT: "user/upload-document",
  SET_TRANSACTION_PIN: "user/transaction-pin",
  RESEND_EMAIL_LINK: "user/resend-link",
  KYC_SUBMIT: "user/kyc-verification",
  SET_WALLET: "user/bank-account",
  KEY_VERIFICATION: "user/kyc-verification",
  PROFILE: "user/profile",
  UPLOAD_IMAGE: "user/profile-picture",
  TRANSACTION_HISTORY: "payment/money/transaction-history",
  TRANSACTION_STATEMENT: "merchant/merchant-transaction-statement",
  UPDATE_PROFILE_IMAGE: "merchant/profile-photo-update",
  URL_TO_BASE64: "user/image-to-base64",
  CREATE_MERCHANT: "merchant/register",
  VERIFY_MERCHANT_EMAIL: "merchant/verify-email-otp",
  RESEND_EMAIL_OTP: "merchant/send-email-otp",
  SAVE_MERCHANT_PERSONAL_DETAILS: "merchant/personal-details",
  SAVE_BUSINESS_LOCATION: "merchant/business-address",
  SAVE_BUSINESS_DETAILS: "merchant/business-details",
  BUSINESS_TYPES_LIST: "merchant/type",
  BUSINESS_CATEGORIES_LIST: "merchant/category",
  CREATE_PIN: "merchant/explore-pin",
  SOURCE_OF_INCOME_LIST: "common/source-of-income",
  GET_SUPPORTED_COUNTRIES: "common/country/findRegionData",
};

export const MERCHANT_ROUTES = {
  VERIFY_EMAIL_OTP: "merchant/verify-email-otp-for-update",
  SEND_EMAIL_OTP_UPDATE: "merchant/send-email-otp-for-update",
  SAVE_PHONE: "merchant/send-phone-otp-for-update",
  VERIFY_PHONE_OTP: "merchant/verify-phone-otp-for-update",
  RESET_CONFIRM_PASSWORD: "merchant/edit-password",
  CHANGE_EXPLOREPIN: "merchant/change-explorepin",
  MERCHANT_PROFILE: "merchant/profile",
  BECOME_FOOD_MERCHANT: "foods/become-merchant",
  UPDATE_RESTAURANT_DEFAULT: "foods/restaurant-default",
  GET_DEFAULT_RESTAURANT: "foods/restaurant-default",
  GET_DEFAULT_MENU_LIST: "foods/menu-default",
  GET_MENU: "foods/menu",
  ADD_NEW_MENU: "foods/menu",
  UPDATE_MENU: "foods/menu",
  UPDATE_CAT_ITEMS_ORDER: "foods/menu-category/:categoryId/order",
  UPDATE_CAT_ORDER: "foods/menu/:menuId/cat-order",
  RESTAURANT_STATUS: "foods/restaurant-status",
  GET_CUSTOMISATIONS: "foods/modifier-group",
  CREATE_CUSTOMISATION: "foods/modifier-group",
  MENU_ITEM: "foods/menu-item",
  MENU_ITEM_STOCK: "foods/menu-item/:id/stock",
  GET_MENU_CATEGORIES: "foods/menu-category",
  CREATE_MENU_CATEGORY: "foods/menu-category",
  UPDATE_MENU_CATEGORY: "foods/menu-category",
  MERCHANT_CATEGORY: "foods/public/merchant-categories",
  CONSTANT: "foods/constants",
  REVIEW: "reviews",
  OVERVIEW_ORDER_LISTS: "",
};

export const COUNTRY = {
  COUNTRY: "common/country",
  COUNTRY_FLAG: "common/country/flag",
  SEARCH_COUNTRY: "common/country/list",
  CURRENT_COUNTRY_CODE: "http://ip-api.com/json/?fields=countryCode",
};
export const CARDS = {
  GET_CARDS: "payment/card",
  SET_DEFAULT_CARD: "payment/card",
  ADD_CARD: "payment/card",
  DELETE_CARD: "payment/card",
};

export const BANKS = {
  GET_BANKS: "payment/user-bank/user_banks",
  ADD_BANKS: "payment/user-bank/create-bank-detail",
  SET_DEFAULT_BANK: "payment/user-bank/update-bank-primary-status",
  DELETE_BANK: "payment/user-bank/delete-bank",
};
export const OTP_TYPES = {
  SIGN_UP_MOBILE: "signUpMobile",
  SIGN_UP_EMAIL: "signUpEmail",
  FORGOT_PASSWORD_MOBILE: "forgotPasswordMobile",
  FORGOT_PASSWORD_EMAIL: "forgotPasswordEmail",
};

export const AGENT_MERCHANT_CATEGORY = [
  {
    INDIVIDUAL: "Individual",
    CORPORATE: "Corporate",
  },
];

export const TRANSACTION_PIN_CONFIG = {
  PIN_LENGTH: 6,
  PIN_CLASSES: "pin-input-control d-inline",
  PIN_AUTO_FOCUS: true,
  IS_PASSWORD_INPUT: true,
  ALLOW_ONLY_NUMBERS: true,
};

export const PIN_TYPE = {
  OLD_PIN: "oldPin",
  NEW_PIN: "newPin",
  CONFIRM_PIN: "confirmPin",
};

export const ROUTE_PATHS = {
  HOME: "home",
  RESET_PASSWORD: "reset-password/:uniqueCode",
  VERIFY_PASSWORD: "verify-email/:uniqueCode",
  WALLET_SETUP: "wallet-setup",
  MY_WALLET: "my-wallet",
  TRANSACTIONS: "transactions",
  PROFILE: "profile",
  ANALYTICS: "analytics",
  BILL_PAY: "bill-pay",
  PAYMENT_SETTINGS: "settings/payment",
  ADD_MONEY_BANK: "add-money-bank",
  TRANSFER_MONEY: "transfer-money",
  WITHDRAW_MONEY: "transfer-withdraw-money",
  PRIVACY_POLICY: "privacy-policy",
  TERMS_AND_CONDITION: "terms-and-condition",
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot-password",
  EXPLORE_PIN: "explore-pin",
  EMAIL_VERIFY: "email-verify",
  PHONE_VERIFY: "phone-verify",
  RESET_CONFIRM_PASSWORD: "reset-password",
  SETTINGS: "settings",
  GENERAL_SETTINGS: "settings/general",
  Payment_SETTINGS: "settings/payment",
  ADD_CREDIT_CARD: "settings/add-credit-card",
  ADD_DEBIT_CARD: "settings/add-debit-card",
  ADD_BANK: "settings/add-bank",
  CHANGE_PASSWORD: "settings/change-password",
  CHANGE_EXPLORE_PIN: "settings/change-explore-pin",
  NOTIFICATION: "notification",
  NOTIFICATION_CHATS: "notification/chats",
  NOTIFICATION_USERCHAT: "notification/chats/userchat",
  NOTIFICATION_USERPROFILE: "notification/chats/userprofile",
  NOTIFICATION_USERSEND: "notification/chats/usersend",
  NOTIFICATION_USERRECIEVE: "notification/chats/userrecieve",
  NOTIFICATION_USERINPUT: "notification/chats/useriinput",

  ADD_MONEY: "add-money",
  SEND_OR_REQUEST_MONEY: "send-request-money",
  EXPLORE_USER: "explore-user",
  MERCHANT: "merchant",
  RECENT_CONTACT: "recent-contact",
  SECURE_PAYMENTS: "secure-payments",
  TOP_UP: "top-up",
  SUCCESS_COMMON_COMPONENT: "success",
  ADD_MONEY_DEBIT_OR_CREDIT: "add-money/debit-or-credit",
  REQUEST_FROM_FRIEND: "add-money/request-from-friend",
  EXPLORE_MERCHAND: "add-money/explore-merchand",
  EXPLORE_DRIVER: "add-money/explore-driver",
  BANK_TRANSFER_OR_DEPOSIT: "add-money/bank-transfer",
  CHECKOUTLIST: "merchant/sub-merchant",
  ADDEDITCHECKOUT: "merchant/checkout",
  CHANGE_PIN_CHECKOUT: "merchant/change-explorepin",
};

export const CHECKOUT_ROUTE = {
  MERCHANT_SETTLEMENT_LIST: "merchant/checkout/settlement/merchant",
};

export const PROFILE_ROUTE = {
  PROFILE_HOME: "profile",
  EDIT_PROFILE: "edit-profile",
  CHANGE_PASSWORD: "change-password",
  TRANSACTION_PIN: "transation-pin",
  MY_TRANSACTION: "my-transation",
  ACCOUNT_SETTING: "account-setting",
  PAYMENT_SETTING: "payment-setting",
  ADD_MONEY_DASHBOARD: "add-money",
  MY_DOCUMETS: "my-documents",
  MY_COMMISSIONS: "my-commissions",
};
export const ROUTE_PATH = {
  ROOT: "",
  AUTHENTICATION: {
    ABSOLUTE: "",
    AUTH: "auth",
    LOGIN: "login",
    REGISTER: "register",
    REGISTER_STEP_1: "step-1",
    RELATIVE_LOGIN: "/login",
    FORGOT_PASS: "forgot-password",
    EMAIL_VERIFY: "email-verify",
    CHANGE_PASS: "change-password",
    RESET_PASS: "reset-password/:token",
    PHONE_VERIFY: "phone-verify",
  },
  ROUTES: {
    ABSOLUTE: "",
    HOME: "home",
    DASHBOARD: "dashboard",
    TRANSACTIONS: "transaction",
    PAYROLL: "payroll",
    TRANSACTIONS_LIST: "transaction-list",
    CHECKOUTS: "checkout",
    ADDCHECKOUTS: "addcheckout",
    EDITCHECKOUTS: "edit/:id",
    CHANGE_PIN_CHECKOUTS: "change-pin/:id",
    CHANGE_PASSWORD_CHECKOUTS: "change-password/:id",
    STAFF_MEMBERS: "staff-members",
    HISTORY: "history",
    SETTINGS: "settings",
    ANALYTICS: "analytics",
    NOTIFICATION: "notification",
    KYC: "kyc",
    FOOD: "food",
    FOOD_ORDER: "food-order",
  },
};

export const TRANSACTIONGRAPHDURATION = {
  WEEK: "isoWeek",
  MONTH: "month",
  YEAR: "year",
};

export const ChartColors = {
  BLUE: "rgba(2, 60, 99, 1)",
  ORANGE: "rgba(246, 122, 98, 1)",
  GREEN: "rgba(61, 172, 163, 1)",
  WHITE: "rgb(255, 255, 255, 1)",
};
